



































































































































































import { Prop, Component, Mixins, Inject } from 'vue-property-decorator'
import ReferralDetailSummary from '@/views/Tasks/Detail/ReferralDetails/ReferralDetailSummary.vue'
import { Order } from '@/api/model/order'
import { orderStatusses} from '@/api/types'
import { OrderAPI } from '@/api/backend-client'

@Component
export default class OrderDetailSummary extends Mixins(ReferralDetailSummary) {
    @Inject() readonly saveOrder: (order: Order) => Promise<void>
    @Inject() readonly reloadOrder: () => Promise<void>
    @Prop({ required: true }) readonly order!: Order
    editingOrder: Order = null
    loading: boolean = false

    async created(): Promise<void> {
        await this.loadLocalOrderValues()
    }

    async loadLocalOrderValues(): Promise<void> {
        this.editingOrder = this.order.clone()
    }

    async editOrderStatus(): Promise<void> {
        this.changingStatus = true
        await OrderAPI.update(this.editingOrder.id, this.editingOrder)
        await this.reloadOrder()
        await this.loadLocalOrderValues()
        this.changingStatus = false
    }

    async assignToMe(): Promise<void> {
        this.editingOrder.assignedTo = this.$currentUser
        await this.saveOrder(this.editingOrder)
        await this.reloadOrder()
        await this.loadLocalOrderValues()
    }

    openChangeAssignedUserModal(): void {
        this.changeAssignedUserValue = this.order.assignedTo
        this.changeAssignedUserModal = true
    }

    async changeAssignedUser(): Promise<void> {
        this.changeAssignedUserLoading = true
        await this.saveOrder({
            resourceIdentifier: this.order.resourceIdentifier,
            ...this.order,
            assignedTo: this.changeAssignedUserValue,
        } as Order)
        await this.reloadOrder()
        await this.loadLocalOrderValues()
        this.changeAssignedUserLoading = false
        this.changeAssignedUserModal = false
    }

    get isAssignedOrder(): boolean {
        return this.order && this.order.assignedTo !== null
    }

    get canEditOrder(): boolean {
        if (!this.$currentCompany || !this.order || !this.order.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.order.assignedToBranch.company.id
    }

    get isEditableOrder(): boolean {
        return true
    }

    get validOrderStatusses() {
        if (this.order.status === null) {
            return []
        }

        return orderStatusses().map(status => {
            return {
                label: this.$t(`order.status.${status}`),
                value: status,
            }
        })
    }

    get routeToReferral(): object {
        return {
            name: 'tasks_detail',
            params: {
                referralId: this.order.referral.id,
                contactId: this.order.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    async doSaveOrder(): Promise<void> {
        await this.saveOrder(this.order)
    }

    async saveAndUpdateOrder(): Promise<void> {
        this.loading = true
        await Promise.all([
            this.doSaveOrder(),
            this.editOrderStatus(),
        ])
        this.loading = false
    }
}
